<div class="screen screen--detail">

  <header class="detail__hero ga-photo ga-photo--<%= p.photo %>">
    <i class="icon icon--<%= p.icon %> detail__hero-glyph"></i>
    <div class="detail__hero-scrim"></div>
    <button class="detail__round" type="button" data-id="back" aria-label="<%= _lcs( 'Zurück' ) %>"><i class="icon icon--arrow-left"></i></button>
    <button class="detail__round detail__round--right" type="button" data-id="fav" aria-label="<%= _lcs( 'Merken' ) %>"><i class="icon icon--heart"></i></button>
  </header>

  <div class="detail__body">
    <div class="detail__badges">
      <span class="badge badge--accent"><%= p.cat %></span>
      <span class="badge badge--sky"><%= p.meta.split(' · ')[0] %></span>
    </div>
    <h1 class="detail__title detail__title--lg"><%= p.title %></h1>

    <div class="factrow">
      <span class="factrow__item"><i class="icon icon--footprints"></i> <%= p.duration %></span>
      <span class="factrow__item"><i class="icon icon--trending-up"></i> <%= p.level %></span>
      <span class="factrow__item"><i class="icon icon--star factrow__star"></i> <%= p.rating %></span>
    </div>

    <p class="detail__text"><%= p.desc %></p>

    <div class="locationcard">
      <div class="locationcard__media ga-photo ga-photo--<%= p.photo %>"></div>
      <div class="locationcard__row">
        <i class="icon icon--map-pin"></i>
        <span><%= p.address %></span>
      </div>
    </div>

    <button class="btn btn--primary btn--lg btn--block" type="button" data-id="route">
      <i class="icon icon--navigation"></i> <%= _lcs( 'Route starten' ) %>
    </button>
  </div>

</div>
